import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.702 22H6.765A1.757 1.757 0 0 1 5 20.245V3.755C5 2.784 5.788 2 6.765 2h8.227c.977 0 1.765.784 1.765 1.755V6.57"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.166 16.01s-2.295 3.124-2.335 2.374-.119-2.458-.119-2.458l-.21-.004A2 2 0 0 1 9.54 13.84l.174-4.214A2.5 2.5 0 0 1 12.22 7.23l6.49.025a1.99 1.99 0 0 1 1.987 1.984c.004 1.729 0 4.097-.048 4.98 0 .542-.396 1-.87 1.084-.1.013-.489.054-.94.048m0 0c-.98-.013-2.26-.248-1.527-1.475.83-.638 1.772.453 1.527 1.475m0 0c-.159.662-.816 1.296-2.326 1.41"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const NoInstallIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
